import { useTranslation } from 'react-i18next'
import config from '../config'

export const VideoSection: React.FC = () => {
  const { t } = useTranslation()

  // Don't render if no video ID configured
  if (!config.content.youtubeVideoId) {
    return null
  }

  return (
    <section id="demo" className="py-20 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('video.title', 'See how it works')}
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            {t('video.subtitle', 'Watch a quick demo of our AI-powered domain generator in action')}
          </p>
        </div>

        {/* Responsive YouTube Embed */}
        <div className="relative w-full max-w-4xl mx-auto">
          {/* 16:9 Aspect Ratio Container */}
          <div className="relative pb-[56.25%] h-0 rounded-xl overflow-hidden shadow-2xl">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={`https://www.youtube-nocookie.com/embed/${config.content.youtubeVideoId}?rel=0&modestbranding=1`}
              title={t('video.title', 'Product Demo')}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        {/* Optional CTA below video */}
        <div className="text-center mt-12">
          <button
            onClick={() => {
              const mainAppUrl = config.urls.mainApp
              window.location.href = mainAppUrl
            }}
            className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all duration-200 text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            {t('video.cta', 'Try it yourself →')}
          </button>
        </div>
      </div>
    </section>
  )
}
